<template>
  <div class="reportStepWrapper">
    <PowerbiReport
      :reportId="reportId"
      :workspaceId="workspaceId"
      :venueFilterColumn="venueFilterColumn"
      :venueFilterTable="venueFilterTable"
      :venueFilter="true"
      :filterVenue="activeVenue.venueId"
      :showLoading="false"
      :showNavbar="false"
      :fitToWidth="true"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PowerbiReport from "@/components/PowerbiReport";

export default {
  data() {
    return {
      venueFilterColumn: "id_rekom_life_venue",
      venueFilterTable: "_id_master",
      workspaceId: "afa6e1f5-c992-4df0-b26d-ae60217b531d",
      reportId: "39690035-ee3c-421b-b868-aeb8dbe6b7f2",
    };
  },
  components: { PowerbiReport },
  methods: {},
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
    }),
  },
  async created() {},
  async mounted() {
    console.log("mounted with active venue", this.activeVenue);
  },
};
</script>

<style lang="scss" scoped>
.reportStepWrapper {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;

/*   #powerbi-wrapper {
    aspect-ratio: 4/3;
    max-width: 100%;
  } */
}
</style>